import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, border, mediaQuery } = baseVariables;

export const StyledIntlRfpEventInfo = styled.div`
  background-color: ${color.neutral10};
`;

export const StyledIntlRfpEventInfoForm = styled.div`
  padding: ${toRem(40)} ${toRem(16)};
  border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
  background-color: ${color.base20};
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  .event-info-title {
    padding-bottom: ${toRem(40)};
  }

  @media ${mediaQuery.md} {
    padding: ${toRem(40)} ${toRem(60)};
    border-radius: ${toRem(12)};
  }

  @media ${mediaQuery.lg} {
    padding: ${toRem(40)} ${toRem(94)};
  }
`;

export const StyledDivider = styled.div`
  margin: ${toRem(40)} 0;
  border-top: ${toRem(1)} solid ${color.neutral30};
  &.user-address-info-divider {
    margin: ${toRem(8)} 0 ${toRem(40)};
  }
`;

export const StyledCtaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${toRem(32)} 0;

  .submit-cta {
    width: 90%;
  }

  @media ${mediaQuery.md} {
    justify-content: flex-end;

    .submit-cta {
      width: auto;
    }
  }
`;
